__webpack_require__.p = "https://www.demo.restaurants.novatab.com/";